import request from '@/utils/request'

const prefix = '/django_rest/world-location'

export default {
  getCommonCityList (params) {
    return request.get(`${prefix}/common/city/`, { params })
  },
  getCityRegionList (cityId, params) {
    return request.get(`${prefix}/city/${cityId}/region/`, { params })
  },
  getCityRegionCbdList (cityId, regionId, params) {
    return request.get(`${prefix}/city/${cityId}/region/${regionId}/cbd/`, { params })
  },
  getCountryList () {
    return request.get('/django_rest/location/country/')
  },
  getProvinceList (params) {
    return request.get(`/django_rest/location/${params.parentId}/province/`)
  },
  getCityList (params) {
    return request.get(`/django_rest/location/${params.parentId}/city/`)
  },
  getWorldLocationList (params) {
    return request.get(`${prefix}/`, { params })
  }
}
